export default __webpack_public_path__ + "static/media/ahrqi-logo.bd56c05d.png";